import script from "./Choose.vue?vue&type=script&setup=true&lang=js"
export * from "./Choose.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__